export const LocationsResource = {
  name: "Locations",
  path: "/inventory/locations",
  access: ["read-binlocations"],
};
